// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17R8_","content":"styles_content__AwyWA","row":"styles_row__BLipc","footer":"styles_footer__38EKg","phraseLength":"styles_phraseLength__zwHsf"};